import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { QatchComponent } from 'src/app/components/qatch.component';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-shipping-policy',
  templateUrl: './shipping-policy.component.html',
  styleUrls: ['./shipping-policy.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class ShippingPolicyComponent extends QatchComponent {
  
  constructor(
    protected override deviceService: DeviceDetectorService,
    protected override authService: AuthService
  ) { 
    super(deviceService, authService);
  }
  
}
